module.exports = __webpack_public_path__ + "static/media/gorra (11).08b7c91b.png";